import { getThemeName } from './getThemeName';

type Theme = { default: Record<string, string> };

function setColors(colors: Record<string, string>, element: HTMLElement = document.documentElement): void {
  Object.keys(colors).forEach((name: string) => {
    element.style.setProperty(name, colors[name]);
  });
}

export async function setupTheme(theme: string, element?: HTMLElement): Promise<void> {
  const loadedTheme: Theme = await import(`@uikit/ui-kit/colors/js/${getThemeName(theme)}.js`);

  setColors(loadedTheme.default, element);
}
